import { AdministratorDto } from './AdministratorDto';
import { Media } from './MeidaDto';

export interface InquiryMedia {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  media: Media;
}

export interface InquiryCustomer {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  aId: string;
  name: string;
  nick: string;
  email: string;
  type: string;
}

export interface InquiryAnswer {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  content: string;
  administrator: AdministratorDto;
}

export type InquiryAnswerStatusType = '답변 대기' | '답변 완료';

export default class InquiryDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  content: string;
  inquiryCategory: string;
  inquiryAnswerStatus: InquiryAnswerStatusType;
  customer: InquiryCustomer;
  inquiryMedias: InquiryMedia[];
  inquiryAnswer: InquiryAnswer;
}
